import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { ContentEditableModule } from '@containers/i18n/content-editable/content-editable.module'
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { LightboxModule } from 'ngx-lightbox'
import { SharedModule } from './../../shared/shared.module'
import { PropertyPhotoGalleryComponent } from './property-photo-gallery.component'

@NgModule({
  declarations: [PropertyPhotoGalleryComponent],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    SharedModule,
    LightboxModule,
    ContentEditableModule,
  ],
  exports: [PropertyPhotoGalleryComponent],
})
export class PropertyPhotoGalleryModule {}
